import { useState, type PropsWithChildren } from "react";
import {
  PrimaryControlsStripToolbarHeightContext,
  createPrimaryControlsStripToolbarHeightRegistry,
} from "#primary-controls-strip-toolbar-height-context";

/**
 * Wraps the subtree containing both the `NavLayout` fade and every `PrimaryControlsStripToolbar` callsite.
 */
export function PrimaryControlsStripToolbarHeightProvider({ children }: PropsWithChildren) {
  const [registry] = useState(() => createPrimaryControlsStripToolbarHeightRegistry());
  return (
    <PrimaryControlsStripToolbarHeightContext.Provider value={registry}>
      {children}
    </PrimaryControlsStripToolbarHeightContext.Provider>
  );
}
